__turbopack_context__.v({
  "root": "mantineAnchor-module-scss-module__FSHOqq__root",
});
